import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TestLoanCreateModalUI from './TestLoanCreateModalUI.js'

class TestLoanCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      loanName: 'Test',
      loanNameError: null,
      status: '',
      statusError: null,
      statusList: [],
      subStatus: '',
      subStatusError: null,
      subStatusList: [],
      loanType: 'project',
      loanTypeError: null,
      loanTypeList: [],
      loanSubType: '',
      loanSubTypeError: null,
      loanSubTypeList: [],
      appFlavor: 'classic',
      appFlavorError: null,
      appFlavorList: [],
      loanPurpose: 'other',
      loanPurposeError: null,
      loanPurposeList: [],
      loanAmountF: '100000',
      loanAmountFError: null,
      tenureMonths: '12',
      tenureMonthsError: null,
      interestTenureMonths: 6,
      interestTenureMonthsError: null,
      showInterestTenureMonths: false,
      interestRate: '15',
      interestRateError: null,
      disbursementDate: '',
      disbursementDateError: null,
      capex: false,
      sectorList: [],
      loanTenureMonths: '',
      LoanTenureMonthsError: null,
      loanSubTypeList: [],
    }
  }

  render() {
    return (
      <TestLoanCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createLoanMode={this.props.createLoanMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelCreateLoan={this.onCancelCreateLoan}
        // form fields
        loanName={this.state.loanName}
        onLoanNameChange={(event) => { this.setState({ loanName: event.target.value }) }}
        loanNameError={this.state.loanNameError}
        setLoanNameError={(error) => { this.setState({ loanNameError: error }) }}
        //
        status={this.state.status}
        onStatusChange={this.onStatusChange}
        statusError={this.state.statusError}
        setStatusError={(error) => { this.setState({ statusError: error }) }}
        statusList={this.state.statusList}
        //
        subStatus={this.state.subStatus}
        onSubStatusChange={(event) => { this.setState({ subStatus: event.target.value }) }}
        subStatusError={this.state.subStatusError}
        setSubStatusError={(error) => { this.setState({ subStatusError: error }) }}
        subStatusList={this.state.subStatusList}
        //
        loanAmountF={this.state.loanAmountF}
        onLoanAmountFChange={(event) => { this.setState({ loanAmountF: event.target.value }) }}
        loanAmountFError={this.state.loanAmountFError}
        setLoanAmountFError={(error) => { this.setState({ loanAmountFError: error }) }}
        //
        tenureMonths={this.state.tenureMonths}
        onTenureMonthsChange={(event) => { this.setState({ tenureMonths: event.target.value }) }}
        tenureMonthsError={this.state.tenureMonthsError}
        setTenureMonthsError={(error) => { this.setState({ tenureMonthsError: error }) }}
        //
        interestTenureMonths={this.state.interestTenureMonths}
        onInterestTenureMonthsChange={(event) => { this.setState({ interestTenureMonths: event.target.value }) }}
        interestTenureMonthsError={this.state.interestTenureMonthsError}
        setInterestTenureMonthsError={(error) => { this.setState({ interestTenureMonthsError: error }) }}
        showInterestTenureMonths={this.state.showInterestTenureMonths}
        //
        interestRate={this.state.interestRate}
        onInterestRateChange={(event) => { this.setState({ interestRate: event.target.value }) }}
        interestRateError={this.state.interestRateError}
        setInterestRateError={(error) => { this.setState({ interestRateError: error }) }}
        //
        disbursementDate={this.state.disbursementDate}
        onDisbursementDateChange={(disbursementDate) => { this.setState({ disbursementDate: disbursementDate }) }}
        disbursementDateError={this.state.disbursementDateError}
        setDisbursementDateError={(error) => { this.setState({ disbursementDateError: error }) }}
        //
        loanType={this.state.loanType}
        onLoanTypeChange={this.onLoanTypeChange}
        loanTypeError={this.state.loanTypeError}
        setLoanTypeError={(error) => { this.setState({ loanTypeError: error }) }}
        loanTypeList={this.state.loanTypeList}
        //
        loanSubType={this.state.loanSubType}
        onLoanSubTypeChange={(event) => { this.setState({ loanSubType: event.target.value }) }}
        loanSubTypeError={this.state.loanSubTypeError}
        setLoanSubTypeError={(error) => { this.setState({ loanSubTypeError: error }) }}
        loanSubTypeList={this.state.loanSubTypeList}
        //
        appFlavor={this.state.appFlavor}
        onAppFlavorChange={this.onAppFlavorChange}
        appFlavorError={this.state.appFlavorError}
        setAppFlavorError={(error) => { this.setState({ appFlavorError: error }) }}
        appFlavorList={this.state.appFlavorList}
        //
        loanPurpose={this.state.loanPurpose}
        onLoanPurposeChange={this.onLoanPurposeChange}
        loanPurposeError={this.state.loanPurposeError}
        setLoanPurposeError={(error) => { this.setState({ loanPurposeError: error }) }}
        loanPurposeList={this.state.loanPurposeList}
        sectorList={this.state.sectorList}
        //
        capex={this.state.capex}
        onCapexChange={(event) => { this.setState({ capex: !this.state.capex }) }}
        //
        loanTenureMonths={this.state.loanTenureMonths}
        onLoanTenureMonthsChange={(event) => { this.setState({ loanTenureMonths: event.target.value }) }}
        loanTenureMonthsError={this.state.loanTenureMonthsError}
        setLoanTenureMonthsError={(error) => { this.setState({ loanTenureMonthsError: error }) }}
      />
    )
  }

  onLoanTypeChange = (event) => {
    this.setState({
      loanType: event.target.value,
      showInterestTenureMonths: event.target.value === 'int_then_prj'
    })
  }

  onAppFlavorChange = (event) => {
    this.setState({
      appFlavor: event.target.value,
    })
  }

  onLoanPurposeChange = (event) => {
    this.setState({
      loanPurpose: event.target.value,
    })
  }

  onCancelCreateLoan = () => {
    this.setState({
      submitted: false, successMsg: null, errorList: null,
      loanName: null, statusError: null, subStatusError: null,
      loanTypeError: null, loanSubTypeError: null, appFlavorError: null, loanPurposeError: null,
      loanAmountFError: null, interestRateError: null, disbursementDateError: null
    })
    this.props.onCancelCreateLoan()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    let statusList = [
      { key: 'requested', value: 'requested' },
      { key: 'term_sheet', value: 'term_sheet' },
      { key: 'sanctioned', value: 'sanctioned' },
      { key: 'disbursed', value: 'disbursed' },
    ]
    // let loanTypeList = [
    //   { key: 'project', value: 'Amortized' },
    //   { key: 'interest_only', value: 'Interest only' },
    //   { key: 'int_then_prj', value: 'Hybrid' },
    //   { key: 'inv_discount', value: 'Receivable financing' },
    //   { key: 'lease', value: 'Lease' },
    // ]
    let appFlavorList = [
      { key: 'classic', value: 'Classic' },
      { key: 'small_loan', value: 'Straight-through processing (STP)' },
    ]
    let loanPurposeList = [
      { key: 'e_mobility', value: 'E-Mobility' },
      { key: 'renewable_energy', value: 'Renewable Energy' },
      { key: 'agri_tech', value: 'Agri Tech' },
      { key: 'health_tech', value: 'Health Tech' },
      { key: 'other', value: 'Other - Climate/ESG Project' },
    ]
    this.setState({
      statusList: statusList,
      // loanTypeList: loanTypeList,
      appFlavorList: appFlavorList, loanPurposeList: loanPurposeList
    })
    this.getLoanSubTypeList(context)
    this.getSectors(context)
    this.getLoanTypeList(context)
  }

  getLoanTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/loanTypes`,
      cacheKey: CacheKeys.LoanTypeList(),
      callback: this.getLoanTypeListCallback,
      ttlInSecs: 36000
    })
    cacheManager.getObject2(context)
  }

  getLoanTypeListCallback = (response) => {
    console.log('Response received:', response);

    if (response.keyValueList) {
      this.setState({ loanTypeList: response.keyValueList })
    } else {
      console.error('Error fetching loan type list:', response);
    }
  }

  onStatusChange = (event) => {
    let status = event.target.value
    let subStatusList = []
    switch (status) {
      case 'requested':
        subStatusList = [
          { key: 'draft', value: 'draft' },
          { key: 'appl_fee_paid', value: 'appl_fee_paid' },
          { key: 'fin_docs_collected', value: 'fin_docs_collected' },
          { key: 'project_added', value: 'project_added' },
          { key: 'references_added', value: 'references_added' },
          { key: 'draft_bills_added', value: 'draft_bills_added' },
          { key: 'term_sheet_requested', value: 'term_sheet_requested' }
        ]
        break;
      case 'term_sheet':
        subStatusList = [
          { key: 'term_sheet_review', value: 'term_sheet_review' },
          { key: 'term_sheet_offered', value: 'term_sheet_offered' },
          { key: 'processing_fee_1_paid', value: 'processing_fee_1_paid' },
          // { key: 'term_sheet_accepted', value: 'term_sheet_accepted' },
          { key: 'sanction_requested', value: 'sanction_requested' },
        ]
        break;
      case 'sanctioned':
        subStatusList = [
          { key: 'sanction_accepted', value: 'sanction_accepted' },
          { key: 'bills_added', value: 'bills_added' },
          { key: 'documents_signed', value: 'documents_signed' },
          { key: 'documents_upload', value: 'documents_upload' },
          { key: 'documents_uploaded', value: 'documents_uploaded' },
          { key: 'processing_fee_2_paid', value: 'processing_fee_2_paid' },
          { key: 'disbursement_request', value: 'disbursement_request' },
        ]
        break;
      case 'disbursed':
        subStatusList = [
          { key: 'good_standing', value: 'good_standing' },
          { key: 'delinquent', value: 'delinquent' },
        ]
        break;
      default:
    }
    this.setState({ status: status, subStatus: '', subStatusList: subStatusList })
  }

  getLoanSubTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/loan/subTypes`,
      cacheKey: CacheKeys.LoanSubTypeList(),
      callback: this.getLoanSubTypeListCallback,
      ttlInSecs: 36000
    })
    cacheManager.getObject2(context)
  }

  getLoanSubTypeListCallback = (response) => {
    let loanSubTypeList = response.loanSubTypeList.map((loanSubType) => {
      return { key: loanSubType.code, value: loanSubType.title }
    });
    this.setState({ errorList: response.errorList, loanSubTypeList: loanSubTypeList })
  }

  getSectors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/references`,
      cacheKey: CacheKeys.Sectors(),
      callback: this.getSectorsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSectorsCallback = (response) => {
    let sectorList = response.sectorList.map((sectors) => {
      return { key: sectors.name, value: sectors.label };
    });
    this.setState({ errorList: response.errorList, sectorList: sectorList })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/test/accounts/${this.props.selectedAccountId}/loans`,
      this.onSubmitCallback, {
      status: this.state.status,
      subStatus: this.state.subStatus,
      loanAmountF: this.state.loanAmountF,
      tenureMonths: this.state.tenureMonths,
      interestTenureMonths: this.state.interestTenureMonths,
      interestRate: this.state.interestRate,
      disbursementDate: this.state.disbursementDate,
      loanType: this.state.loanType,
      loanSubType: this.state.loanType === 'project' ? this.state.loanSubType : null,
      appFlavor: this.state.appFlavor,
      purpose: this.state.loanPurpose,
      loanName: this.state.loanName,
      capex: this.state.capex,
      loanTenureMonths: this.state.loanTenureMonths,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loans())
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreateLoan()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default TestLoanCreateModalSF
